import $ from "jquery";

/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
// Place all the behaviors and hooks related to the matching controller here.
// All this logic will automatically be available in application.js.
// You can use CoffeeScript in this file: http://jashkenas.github.com/coffee-script/

$(function() {

  if ($('#controller-static_pages').length === 0) { return; }

  if ($('.action-demo').length > 0) {

    // $('#main').hide()

    // Disable Ctrl+A / Cmd+A
    return $(document).on('keydown', function(e) {
      if (e.metaKey && (e.keyCode === 65)) {
        return false;
      }
    });
  }
}); // Makes sure no text is being selected
